import React from "react";
import { FaFacebook, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";
import styled, { createGlobalStyle } from "styled-components";
import logo from "../Assets/logo.png";
import Team from "../Components/OurTeam"; // Import the Team component

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    font-family: Arial, sans-serif;
  }
`;

const About = React.forwardRef((props, ref) => {
  return (
    <>
      <GlobalStyle />
      <AboutSection ref={ref}>
        <Heading>ABOUT INA–ANI</Heading>

        <ContentWrapper>
          <TextWrapper>
            <Paragraph>
              Ina-Ani is a platform dedicated to empowering women organizations and farmers, cultivating sustainable agricultural practices. Through education, resource accessibility, and innovative solutions, Ina-Ani promotes food security, environmental resilience, and community development. By integrating traditional knowledge with modern technology, we strive to create a thriving, self-sufficient agricultural ecosystem that uplifts local communities and fosters long-term sustainability.
            </Paragraph>
          </TextWrapper>
          <LogoWrapper>
            <LogoImg src={logo} alt="Ina-Ani Logo" />
          </LogoWrapper>
        </ContentWrapper>

        <Team />

        {/* MISSION AND VISION SECTION */}
        <Section>
          <SubHeading>OUR MISSION</SubHeading>
          <ContentWrapper>
            <TextWrapper>
              <Paragraph>
                Ina-Ani is committed to empowering local farmers by providing resources, education, and sustainable practices that enhance food production and security. We advocate for equitable food accessibility, promote agricultural awareness, and preserve cultural heritage by integrating traditional wisdom with modern solutions.
              </Paragraph>
            </TextWrapper>
          </ContentWrapper>

          <SubHeading>OUR VISION</SubHeading>
          <ContentWrapper>
            <TextWrapper>
              <Paragraph>
                Ina-Ani envisions a future where empowered local farmers drive sustainable food systems, ensuring food accessibility and security for all. Through agricultural education, cultural preservation, and community-driven initiatives, we strive to create a resilient and thriving ecosystem.
              </Paragraph>
            </TextWrapper>
          </ContentWrapper>
        </Section>

        {/* OUR GOAL SECTION */}
        <Section>
          <SubHeading>OUR GOAL</SubHeading>
          <ContentWrapper>
            <TextWrapper>
              <Paragraph>
                Our goal is to strengthen local agricultural communities by increasing farmers’ access to sustainable practices, education, and market opportunities. We aim to enhance food security, promote eco-friendly farming methods, and preserve cultural heritage.
              </Paragraph>
            </TextWrapper>
          </ContentWrapper>
        </Section>

        {/* CONTACT SECTION */}
        <ContactSection>
          <LeftCol>
            <LogoRow>
              <LogoIcon src={logo} alt="INA-ANI Logo" />
              <div>
                <strong>INA–ANI</strong>
                <Tagline>Nurturing Harvests, Empowering Women</Tagline>
              </div>
            </LogoRow>
            <IconRow>
              <SocialIcon bgColor="#3b5998" href="https://facebook.com" aria-label="Facebook">
                <FaFacebook />
              </SocialIcon>
              <SocialIcon bgColor="#db4437" href="mailto:ina-ani@gmail.com" aria-label="Gmail">
                <BiLogoGmail />
              </SocialIcon>
            </IconRow>
          </LeftCol>

          <RightCol>
            <SubHeading>Get in touch</SubHeading>
            <ContactItem>
              <FaPhone /> +123-456-7890
            </ContactItem>
            <ContactItem>
              <BiLogoGmail /> ina-ani@gmail.com
            </ContactItem>
            <ContactItem>
              <FaMapMarkerAlt /> Bohol Island State University - Bilar Campus
            </ContactItem>
          </RightCol>
        </ContactSection>
      </AboutSection>
    </>
  );
});

export default About;

// Styled Components
const AboutSection = styled.section`
  background: #fff;
  padding: clamp(1rem, 5vw, 2rem);
  text-align: center;
  min-height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;

  @media (max-width: 600px) {
    padding: clamp(0.75rem, 4vw, 1.5rem);
  }
`;

const Heading = styled.h2`
  font-size: clamp(1.5rem, 5vw, 2rem);
  color: #006400;
  font-weight: 800;
  margin: clamp(2rem, 8vw, 5rem) 0 clamp(1rem, 3vw, 1.5rem);
`;

const SubHeading = styled.h3`
  font-size: clamp(1.2rem, 4vw, 1.5rem);
  color: #006400;
  font-weight: 700;
  margin: clamp(0.5rem, 2vw, 1rem) 0;
  text-align: left;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: clamp(1rem, 3vw, 2rem);
  margin-bottom: clamp(1rem, 3vw, 2rem);
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const TextWrapper = styled.div`
  flex: 1;
  min-width: 280px;
  text-align: justify;
`;

const Paragraph = styled.p`
  font-size: clamp(0.9rem, 2.5vw, 1.1rem);
  line-height: 1.8;
  color: #333;
  width: 100%;
  text-align: justify;

  @media (max-width: 600px) {
    font-size: clamp(0.8rem, 2.5vw, 1rem);
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 200px;
`;

const LogoImg = styled.img`
  width: clamp(150px, 30vw, 200px);
  max-width: 100%;
  height: auto;
`;

const Section = styled.div`
  padding: clamp(1rem, 3vw, 2rem) 0;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContactSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-top: 2px solid #ccc;
  padding: clamp(1rem, 3vw, 1.5rem) 0;
  gap: clamp(1rem, 3vw, 2rem);
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftCol = styled.div`
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const RightCol = styled.div`
  flex: 1;
  min-width: 280px;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(0.5rem, 2vw, 1rem);
  margin-bottom: clamp(0.5rem, 2vw, 1rem);
`;

const LogoIcon = styled.img`
  width: clamp(40px, 10vw, 50px);
  height: auto;
`;

const Tagline = styled.p`
  font-size: clamp(0.8rem, 2vw, 0.9rem);
  color: #006400;
`;

const IconRow = styled.div`
  display: flex;
  gap: clamp(0.5rem, 2vw, 1rem);
`;

const SocialIcon = styled.a`
  width: clamp(32px, 8vw, 40px);
  height: clamp(32px, 8vw, 40px);
  background-color: ${({ bgColor }) => bgColor || "#333"};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: clamp(1rem, 3vw, 1.2rem);
  text-decoration: none;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const ContactItem = styled.p`
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;